/**
 * HTTP client for the care dashboard backend (not Care API SDK).
 * Configure: REACT_APP_CARE_API_URL (e.g. https://api.example.com)
 */

export function getCareApiBaseUrl() {
  return (process.env.REACT_APP_CARE_API_URL || 'https://api.nvoisyshealth.in/api').replace(/\/$/, '');
}

export function requireCareApiBaseUrl() {
  const base = getCareApiBaseUrl();
  if (!base) {
    throw new Error(
      'REACT_APP_CARE_API_URL is not set. Point it at your care API base URL.'
    );
  }
  return base;
}

/**
 * @param {string} path - Absolute path on API host, e.g. /doctor-profiles
 * @param {{ token?: string, params?: Record<string, string | number | boolean | undefined | null> }} options
 */
export async function careApiGet(path, options = {}) {
  const base = requireCareApiBaseUrl();
  const url = new URL(`${base}${path.startsWith('/') ? path : `/${path}`}`);
  if (options.params) {
    Object.entries(options.params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.searchParams.set(key, String(value));
      }
    });
  }

  const headers = { Accept: 'application/json' };
  if (options.token) {
    headers.Authorization = `Bearer ${options.token}`;
  }

  const response = await fetch(url.toString(), { method: 'GET', headers });
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      (payload && (payload.message || payload.error)) ||
      `Request failed (${response.status})`;
    throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
  }

  return payload;
}

/**
 * @param {string} path
 * @param {{ token?: string, body?: unknown }} options
 */
export async function careApiPost(path, options = {}) {
  const base = requireCareApiBaseUrl();
  const url = `${base}${path.startsWith('/') ? path : `/${path}`}`;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (options.token) {
    headers.Authorization = `Bearer ${options.token}`;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined
  });
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      (payload && (payload.message || payload.error)) ||
      `Request failed (${response.status})`;
    throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
  }

  return payload;
}

/** Normalize list payloads: raw array, or { items | data | records }. */
export function normalizeListResponse(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.records)) return payload.records;
  return [];
}
